var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "min-w-0 w-full" }, [
    !_vm.element_path
      ? _c(
          "div",
          [
            _vm.element == _vm.items[0] || _vm.element_path == 0
              ? _c("news", { attrs: { isModal: "" } })
              : _vm._e(),
            _vm.element == _vm.items[1] || _vm.element_path == 1
              ? _c("faq", { attrs: { isModal: "" } })
              : _vm._e(),
            _vm.element == _vm.items[2] || _vm.element_path == 2
              ? _c("videos", { attrs: { isModal: "" } })
              : _vm._e(),
            _vm.element == _vm.items[3] || _vm.element_path == 3
              ? _c("sugerences", { ref: "sugerences", attrs: { isModal: "" } })
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          [
            _vm.element == _vm.items[0] || _vm.element_path == 0
              ? _c("news", { attrs: { module_path: _vm.module_path } })
              : _vm._e(),
            _vm.element == _vm.items[1] || _vm.element_path == 1
              ? _c("faq")
              : _vm._e(),
            _vm.element == _vm.items[2] || _vm.element_path == 2
              ? _c("videos")
              : _vm._e(),
            _vm.element == _vm.items[3] || _vm.element_path == 3
              ? _c("sugerences", { ref: "sugerences" })
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }